export const directorApi = {
	domain: 'https://czc.guanmini.com',
	main: 'https://czc.guanmini.com/admin', //主域名
    // domain: 'https://www.guanmini.com',
	// main: 'https://www.guanmini.com/api', //主域名
	login:'/president/Login/index',
    userInfo:'/president/Login/getUserInfo',
    editUserInfo: '/president/Login/editUserInfo',
    changePassword: '/president/Login/changePassword',
    schoolList: '/president/schools/schoolList',
    classList: '/president/Progress/classList',
    classProgressList: '/president/progress/classProgressList',
    studentProgressList: '/president/progress/studentList',
    classProgressList: '/president/progress/classProgressList',
    schoolList: '/president/schools/schoolList',
    studentProgressList: '/president/progress/studentList',
    getToken: '/schools/Login/getAuth'
}

export const leaderApi = {
    domain: 'https://czcszpg.dzuo.net',
    main: 'https://czcszpg.dzuo.net/eval', //主域名

    allClassList: '/leader/getCDClassList.htm',
    studentList: '/leader/getCDStudentList.htm',
    getObserActList: '/leader/getObserActCatList.htm',
    getObserRebackList: '/leader/getObserStrategyList.htm',
    getObserSceneList: '/leader/getObserSceneCatList.htm',
    getObserGuideList: '/leader/getObserGuidanceList.htm',
    getFieldList: '/leader/getTestFieldList.htm',
    getSecFieldList: '/leader/getTestTarget3List.htm',
    saveObserve: '/leader/saveObserRecord.htm',
    getTemplateList: '/leader/getTemplateList.htm',
    upload: '/phone/addPhoto.htm',
    getObserRecordList: '/leader/getObserAllList.htm',
    getObserRecordDetail: '/leader/getObserRecordDetail.htm',
    getObserTaskList: '/leader/getObserTaskList.htm',
    getGroupStudentList:'/leader/getGroupStudentList.htm',
    delObserAll: '/leader/deleteObserAll.htm',
    getCDTeacherList: '/leader/getCDTeacherList.htm',
    saveNotable: '/leader/saveObserNotable.htm',
    getObserNotableDetail:'/leader/getObserNotableDetail.htm',
    saveObserSelfAct:'/leader/saveObserSelfAct.htm',
    saveObserSelfScene:'/leader/saveObserSelfScene.htm',
    getObserSelfActList:'/leader/getObserSelfActList.htm',
    getObserSelfSceneList: '/leader/getObserSelfSceneList.htm',
    saveDeleteObserSelfScene: '/leader/saveDeleteObserSelfScene.htm',
    saveDeleteObserSelfAct: '/leader/saveDeleteObserSelfAct.htm',
    saveObTask: '/leader/saveObserTask.htm',
    getObserTaskList: '/leader/getObserTaskList.htm',
    getSchoolGradeList: '/leader/getSchoolGradeList.htm',
    getObserTaskDetail: '/leader/getObserTaskDetail.htm',
    getObserAllDetail: '/leader/getObserAllDetail.htm',
    getAikeyList:'/evaluation/getAikeyList.htm',
    getFileInfo: '/phone/getExportAccessory.htm',
    sendTask: '/leader/saveSendObserTask.htm',
    getTeacherObserCircleList: '/leader/getTeacherObserCircleList.htm',
    getTeacherObserCircleDetail:"/leader/getTeacherObserCircleDetail.htm",
    saveSyncParentObserNotable:'/leader/saveSyncParentObserNotable.htm',
    saveSyncParentObserObserve: '/leader/saveSyncParentObserRecord.htm',
    saveTeacherEditObserCircle: '/leader/saveTeacherEditObserCircle.htm',
    transformCircle: '/leader/saveTransformObserNotable.htm',
    saveTransformObserNotable:'/leader/saveTransformObserNotable.htm',
    getObserStaticSemester: '/evaluation/getObserStaticSemester.htm',
    getClassObserStatic: '/evaluation/getClassObserStatic.htm',
}


export const directorTestApi = {
    domain: 'https://czcszpg.dzuo.net',
    main: 'https://czcszpg.dzuo.net/eval', //主域名

    allClassList: '/evaluation/getCDClassList.htm',
    studentList: '/evaluation/getCDStudentList.htm',
    getObserActList: '/evaluation/getObserActCatList.htm',
    getObserRebackList: '/evaluation/getObserStrategyList.htm',
    getObserSceneList: '/evaluation/getObserSceneCatList.htm',
    getObserGuideList: '/evaluation/getObserGuidanceList.htm',
    getFieldList: '/evaluation/getTestFieldList.htm',
    getSecFieldList: '/evaluation/getTestTarget3List.htm',
    saveObserve: '/evaluation/saveObserRecord.htm',
    getTemplateList: '/evaluation/getTemplateList.htm',
    upload: '/phone/addPhoto.htm',
    getObserRecordList: '/evaluation/getObserAllList.htm',
    getObserRecordDetail: '/evaluation/getObserRecordDetail.htm',
    getObserTaskList: '/evaluation/getObserTaskList.htm',
    getGroupStudentList:'/evaluation/getGroupStudentList.htm',
    delObserAll: '/evaluation/deleteObserAll.htm',
    getCDTeacherList: '/evaluation/getCDTeacherList.htm',
    saveNotable: '/evaluation/saveObserNotable.htm',
    getObserNotableDetail:'/evaluation/getObserNotableDetail.htm',
    saveObserSelfAct:'/evaluation/saveObserSelfAct.htm',
    saveObserSelfScene:'/evaluation/saveObserSelfScene.htm',
    getObserSelfActList:'/evaluation/getObserSelfActList.htm',
    getObserSelfSceneList: '/evaluation/getObserSelfSceneList.htm',
    saveDeleteObserSelfScene: '/evaluation/saveDeleteObserSelfScene.htm',
    saveDeleteObserSelfAct: '/evaluation/saveDeleteObserSelfAct.htm',
    saveObTask: '/evaluation/saveObserTask.htm',
    getObserTaskList: '/evaluation/getObserTaskList.htm',
    getSchoolGradeList: '/evaluation/getSchoolGradeList.htm',
    getObserTaskDetail: '/evaluation/getObserTaskDetail.htm',
    getObserAllDetail: '/evaluation/getObserAllDetail.htm',
    getAikeyList:'/evaluation/getAikeyList.htm',
    getFileInfo: '/phone/getExportAccessory.htm',
    sendTask: '/evaluation/saveSendObserTask.htm',
    getTeacherObserCircleList: '/evaluation/getTeacherObserCircleList.htm',
    getTeacherObserCircleDetail:"/evaluation/getTeacherObserCircleDetail.htm",
    saveSyncParentObserNotable:'/evaluation/saveSyncParentObserNotable.htm',
    saveSyncParentObserObserve: '/evaluation/saveSyncParentObserRecord.htm',
    saveTeacherEditObserCircle: '/evaluation/saveTeacherEditObserCircle.htm',
    transformCircle: '/evaluation/saveTransformObserNotable.htm',
    saveTransformObserNotable:'/evaluation/saveTransformObserNotable.htm',

}

export const reportApi = {
	domain: 'https://czcszpg.dzuo.net',
    main: 'https://czcszpg.dzuo.net/eval', //主域名
    getReportClassList: '/evstatis/getClassReportList.htm', //获取班级列表
    getSchoolStatisList: '/evstatis/getSchoolStatisList.htm', //获取学校统计
    getStudentReportList: '/evstatis/getStudentReportList.htm', //获取学生统计
    getTeacherStatisList: '/evstatis/getTeacherStatisList.htm', //获取教师统计
    getTestFieldStatisList: '/evstatis/getTestFieldStatisList.htm', //获取测试字段统计
    getTestFieldStepStatisList: '/evstatis/getTestFieldStepStatisList.htm', //获取测试字段步骤统计
    refreshSummary: '/phone/dataChange.htm',
    getSemesterMonthList: '/evstatis/getSemesterMonthList.htm',
    getSemesterList: '/evstatis/getSemesterList.htm',
    getClassReportDetail: '/evstatis/getClassReportDetail.htm',
    getStudentReportDetail: '/evstatis/getStudentReportDetail.htm',
    getClassReportList:'/evstatis/getClassReportList.htm',
    getSemesterReportDetail: '/evstatis/getSchoolClassReportDetail.htm',
    getSchoolReportDetail: '/evstatis/getSchoolReportDetail.htm',
    getSchoolClassReportStudentDetail: '/evstatis/getSchoolClassReportStudentDetail.htm',
    saveFiledAiData: '/aiweb/saveTestFieldAnalyse.htm',
    pushRemark:'/evstatis/saveClassObserStaticSemesterStudentRemark.htm'
}


export const aiApi = {
	domain: 'https://czcszpg.dzuo.net',
    main: 'https://czcszpg.dzuo.net/eval', //主域名
    saveFiledAiData: '/aiweb/saveTestFieldAnalyse.htm',
    getAIclassList: '/aiweb/getCozeBotClassList.htm',
    getAIList: '/aiweb/getCozeBotList.htm',
    getRecordList: '/aiweb/getAiTestFieldAnalyseList.htm',
    getRecordDetail: '/aiweb/getAiTestFieldAnalyse.htm',
    deleteRecord: '/aiweb/saveDeleteAiTestFieldAnalyse.htm',
}
